<svg *ngIf="enabled" fill="none" [ngStyle]="svgStyle" viewBox="0 0 66 66">
    <circle cx="33" cy="33" fill="none" r="28" [attr.stroke]="secondaryColor" [attr.stroke-width]="strokeWidth" />
    <circle
        cx="33"
        cy="33"
        fill="none"
        r="28"
        stroke="currentColor"
        stroke-dasharray="1, 174"
        stroke-dashoffset="306"
        stroke-linecap="round"
        [attr.stroke-width]="strokeWidth"
        [ngStyle]="dashStyle"
    />
</svg>
